var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNoButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1608 28.65C16.1968 28.4744 16.193 28.2929 16.1495 28.1189C16.106 27.945 16.024 27.783 15.9095 27.645C15.7942 27.5099 15.6499 27.4026 15.4875 27.331C15.325 27.2593 15.1485 27.2252 14.971 27.2311H10.3672C10.7293 28.1771 11.1062 29.123 11.4461 30.069H14.5572C14.9508 30.0669 15.3298 29.9196 15.6213 29.6551C15.9161 29.3958 16.1076 29.039 16.1608 28.65Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1608 28.65C16.1968 28.4744 16.193 28.2929 16.1495 28.1189C16.106 27.945 16.024 27.783 15.9095 27.645C15.7942 27.5099 15.6499 27.4026 15.4875 27.331C15.325 27.2593 15.1485 27.2252 14.971 27.2311H10.3672C10.7293 28.1771 11.1062 29.123 11.4461 30.069H14.5572C14.9508 30.0669 15.3298 29.9196 15.6213 29.6551C15.9161 29.3958 16.1076 29.039 16.1608 28.65Z",
    fill: "url(#paint0_linear_494_4396)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4601 0.00865188H0L2.79333 7.33975H18.0606C18.6151 7.33787 19.1688 7.38237 19.7159 7.47278C20.7646 7.56352 21.7848 7.86178 22.7172 8.35022C23.6496 8.83866 24.4757 9.50755 25.1474 10.318C25.9505 11.2764 26.5293 12.4022 26.8413 13.6131C27.1532 14.824 27.1906 16.0894 26.9505 17.3166L25.1991 28.5866C24.7771 31.3186 23.3678 33.8008 21.2382 35.563C19.6928 36.9501 17.8005 37.8925 15.7624 38.29C15.452 38.3639 15.1342 38.423 14.8165 38.4674H18.5114C21.9261 38.4563 25.2141 37.1732 27.7338 34.8683C30.3708 32.6887 32.1167 29.6175 32.6406 26.2366L34.8058 12.2616C35.1032 10.7427 35.0586 9.17667 34.6751 7.67719C34.2916 6.17771 33.5789 4.7825 32.5889 3.59291C31.5981 2.41374 30.3502 1.47748 28.941 0.856113C27.5318 0.234749 25.9989 -0.0551673 24.4601 0.00865188Z",
    fill: "url(#paint1_linear_494_4396)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3637 18.2988C17.67 18.0479 17.8727 17.6925 17.9327 17.3011C17.9661 17.1249 17.9603 16.9434 17.9156 16.7697C17.8709 16.596 17.7884 16.4342 17.674 16.2961C17.5643 16.155 17.4228 16.0419 17.2609 15.9661C17.0991 15.8903 16.9215 15.8539 16.7429 15.86H6.03516L7.12145 18.7127H16.3069C16.6992 18.7153 17.0775 18.5672 17.3637 18.2988Z",
    fill: "url(#paint2_linear_494_4396)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_494_4396",
    x1: 34,
    y1: 39.5,
    x2: 7,
    y2: 39.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E30E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_494_4396",
    x1: 48.5,
    y1: 38,
    x2: -4.93897e-7,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E30D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_494_4396",
    x1: 35.5,
    y1: 39,
    x2: 4.5,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E30D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoButton);
export default __webpack_public_path__ + "static/media/logo-no-button.2c637e8d099f6799fa24413d9b3f34b6.svg";
export { ForwardRef as ReactComponent };